import styled from 'styled-components';

export const DiscussionTabContent = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 5px;
  background: ${({ theme }) => theme.freecode.activeAreaBackgroundColor};
`;
